import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X, Mail, FileText, HelpCircle } from "lucide-react";
import { trackEvent } from "../../lib/analytics";
import FitmentAssistModal from "./FitmentAssistModal";

const SUPPORT_EMAIL = "support@lecisautoglass.com";

/**
 * Floating contact widget shown on all storefront pages. Non-intrusive
 * bottom-right launcher with Email / Contact Form / Fitment Assistance.
 */
export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [fitment, setFitment] = useState(false);

  const toggle = () => {
    if (!open) trackEvent("contact_widget_open", {});
    setOpen((v) => !v);
  };

  const openFitment = () => {
    trackEvent("fitment_widget_open", {});
    setOpen(false);
    setFitment(true);
  };

  const onEmail = () => {
    trackEvent("email_click", { source: "floating_widget" });
    setOpen(false);
  };

  return (
    <>
      <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
        {open && (
          <div className="w-60 bg-[#101010] border border-white/10 rounded-xl shadow-2xl overflow-hidden animate-in" data-testid="floating-contact-menu">
            <div className="px-4 py-3 border-b border-white/10">
              <div className="text-sm font-medium text-white">Need a hand?</div>
              <div className="text-[11px] text-zinc-500">We'll help you find the right part.</div>
            </div>
            <a href={`mailto:${SUPPORT_EMAIL}`} onClick={onEmail} data-testid="floating-email" className="flex items-center gap-3 px-4 py-3 text-sm text-zinc-200 hover:bg-white/5 transition">
              <Mail size={16} className="text-red-500" /> Email Us
            </a>
            <Link to="/contact" onClick={() => setOpen(false)} data-testid="floating-contact-form" className="flex items-center gap-3 px-4 py-3 text-sm text-zinc-200 hover:bg-white/5 transition">
              <FileText size={16} className="text-red-500" /> Contact Form
            </Link>
            <button onClick={openFitment} data-testid="floating-fitment" className="w-full flex items-center gap-3 px-4 py-3 text-sm text-zinc-200 hover:bg-white/5 transition text-left">
              <HelpCircle size={16} className="text-red-500" /> Fitment Assistance
            </button>
          </div>
        )}
        <button
          onClick={toggle}
          data-testid="floating-contact-toggle"
          aria-label="Contact options"
          aria-expanded={open}
          className="w-14 h-14 rounded-full bg-red-600 hover:bg-red-700 text-white shadow-xl flex items-center justify-center transition hover:scale-105"
        >
          {open ? <X size={22} /> : <MessageCircle size={22} />}
        </button>
      </div>
      {fitment && <FitmentAssistModal prefill={{}} onClose={() => setFitment(false)} />}
    </>
  );
}
